var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 4,
    fill: "#FBB142"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.116 7H9.88395C8.29375 7 7 8.29389 7 9.88395V22.116C7 23.7063 8.29389 25 9.88395 25H22.116C23.7063 25 25 23.7061 25 22.116V9.88395C25 8.29375 23.7063 7 22.116 7ZM15.9918 21.2374C15.4105 21.2374 14.9392 20.7662 14.9392 20.1848C14.9392 19.6035 15.4104 19.1321 15.9918 19.1321C16.5731 19.1321 17.0445 19.6033 17.0445 20.1848C17.0443 20.7662 16.5731 21.2374 15.9918 21.2374ZM18.2529 15.951C17.6546 16.3964 17.0152 16.7582 16.89 17.5781V18.1072H15.0126V17.4815C15.0957 16.271 15.666 15.729 16.2223 15.2979C16.7646 14.8671 17.2375 14.5474 17.2375 13.796C17.2375 12.9475 16.7927 12.5443 16.0558 12.5443C15.0548 12.5443 14.6375 13.3648 14.6232 14.3522L12.579 14.3524C12.6209 12.3638 13.9281 10.9175 15.9583 10.9175C18.5867 10.9175 19.4215 12.5307 19.4215 13.601C19.4213 14.9502 18.8511 15.4927 18.2529 15.9511L18.2529 15.951Z",
    fill: "#F9F9F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG1);
export default __webpack_public_path__ + "static/media/g1.0554e4144ccaee11abf682508cf8810f.svg";
export { ForwardRef as ReactComponent };